export enum SideFacingModeList {
  SECONDARY_ONLY = 'secondary-only',
  ALLOW_PRIMARY = 'allow-primary'
}

export type ISideFacingModeList = Record<string, string>;

export type SideFacingsModeProps = {
  selectedSideFacingMode: string;
  disabled: boolean;
  handleSideFacingModeChange: (sideFacingMode: string) => void;
};
